"use client";

export const nativeSupportSnapshot =
  typeof document !== "undefined" &&
  ("modelContext" in document || "modelContext" in navigator);
